module.exports = __webpack_public_path__ + "static/media/IMG_1669.fb31cda6.JPG";